import { render, staticRenderFns } from "./ForwardDocumentForm.vue?vue&type=template&id=9e216690&scoped=true&"
import script from "./ForwardDocumentForm.vue?vue&type=script&lang=js&"
export * from "./ForwardDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./ForwardDocumentForm.vue?vue&type=style&index=0&id=9e216690&lang=scss&scoped=true&"
import style1 from "./ForwardDocumentForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e216690",
  null
  
)

export default component.exports